import api from '../service/service.js'
import Swal from 'sweetalert2'
export default {
  name: 'users',
  data () {
    return {
      dataall: [],
      window: {
        width: 0,
        height: 0
      },
      user: JSON.parse(sessionStorage.Data),
      ac_id: JSON.parse(sessionStorage.Data).ac_id,
      prefix_id: 0,
      l_name: '',
      f_name: '',
      username: '',
      password: '',
      conpassword: '',
      gender_id: 1,
      position: '',
      role_id: 0,
      active_status: 1,
      prefix: [],
      gender: [],
      role: []
    }
  },
  computed: {},
  created () {
    window.addEventListener('resize', this.handleResize)
    this.handleResize()
  },
  destroyed () {
    window.removeEventListener('resize', this.handleResize)
  },
  methods: {
    GetGen (val) {
      console.log(val)
      if (val === '1') {
        return 'ชาย'
      } else {
        return 'หญิง'
      }
    },
    Getstatus (val) {
      console.log(val)
      if (val === '1') {
        return 'เปิด'
      } else {
        return 'ปิด'
      }
    },
    handleResize () {
      this.window.width = window.innerWidth
      this.window.height = window.innerHeight
    },
    addUser () {
      if (this.username === '' || this.password === '' || this.l_name === '' || this.f_name === '' || this.position === '') {
        this.alert_msg(
          'error',
          'ข้อความจากระบบ',
          'กรุณากรอกข้อมูลให้ครบถ้วน '
        )
        return 1
      }
      let payload = {
        username: this.username,
        password: this.password,
        prefix_id: this.prefix_id.toString(),
        fname: this.f_name,
        lname: this.l_name,
        gender_id: this.gender_id.toString(),
        position: this.position,
        role_id: this.role_id.toString(),
        active_status: this.active_status.toString()
      }
      console.log(payload)
      api.putuser(
        payload,
        result => {
          console.log(result)
          if (result.result === true) {
            Swal.fire({
              position: 'top-end',
              type: 'success',
              title: 'Your work has been saved',
              showConfirmButton: false,
              timer: 1500
            })
            this.getuser()
          } else {
            Swal.fire({
              position: 'top-end',
              type: 'error',
              title: result.data,
              showConfirmButton: false,
              timer: 1500
            })
          }
        },
        calback => {
          Swal.fire({
            position: 'top-end',
            type: 'error',
            title: calback,
            showConfirmButton: false,
            timer: 1500
          })
          console.log(calback)
        })
    },
    getrolename (array, roleid) {
      for (var i in array) {
        if (array[i].role_id === roleid) {
          return array[i].role_name
        }
      }
      return 1
    },
    getgender () {
      api.gender(
        result => {
          console.log(result)
          if (result.result === true) {
            this.gender = result.data
          }
        },
        calback => {
          console.log(calback)
        })
    },
    getuser () {
      let payload = this.ac_id
      api.getusers(
        payload,
        result => {
          if (result.result === true) {
            console.log(result.data[0].ac_id)
            this.prefix_id = result.data[0].prefix_id
            this.l_name = result.data[0].lname
            this.f_name = result.data[0].fname
            this.username = result.data[0].username
            this.password = result.data[0].password
            this.role_id = result.data[0].role_id
            this.gender_id = result.data[0].gender_id
            this.position = result.data[0].position
            this.active_status = result.data[0].active_status
          }
        }
      )
    },
    getprefix () {
      api.prefix(
        result => {
          console.log(result)
          if (result.result === true) {
            this.prefix = result.data
            console.log(this.prefix)
          }
        },
        calback => {
          console.log(calback)
        })
    },
    getRole () {
      api.role(
        result => {
          console.log(result)
          if (result.result === true) {
            this.role = result.data
          }
        },
        calback => {
          console.log(calback)
        })
    }
  },
  mounted () {
    this.getuser()
    this.getgender()
    this.getprefix()
    this.getRole()
  //  this.getUsers()
  //  console.log(this.menu)
  }
}


// WEBPACK FOOTER //
// ./src/js/profile.js